/* libs/shared/src/lib/ui/pagination/pagination.component.scss */
.pagination-comp {
  display: flex;
  max-width: 98%;
  position: relative;
  left: 10px;
}
.pagination-comp .pagesize-wrapper {
  margin-top: 20px;
  margin-bottom: 20px;
}
.pagination-comp .pagesize-wrapper select {
  margin-right: 10px;
  border-radius: 4px;
  padding: 2px;
  margin-top: -1px;
  background-color: white;
  border: 1px solid lightgray;
}
.pagination-comp .separator {
  flex: 1;
}
.pagination-comp .pagination-wrapper {
  align-items: center;
  display: flex;
  margin-top: 20px;
  margin-bottom: 20px;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}
.pagination-comp .pagination-wrapper .pages-label {
  margin-right: 10px;
}
.pagination-comp .pagination-wrapper select {
  border-radius: 4px;
  padding: 2px;
  margin-top: -1px;
  background-color: white;
  border: 1px solid lightgray;
}
.pagination-comp .pagination-wrapper .page-item {
  cursor: pointer;
  padding-left: 5px;
  padding-right: 5px;
  width: 22px;
  text-align: center;
}
.pagination-comp .pagination-wrapper .page-item.active {
  font-weight: bold;
}
.pagination-comp .pagination-wrapper .page-item:hover {
  background-color: #DADADA;
}
/*# sourceMappingURL=pagination.component.css.map */
